import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ShipmentService} from "../../../../../../open-api-generated/services/shipment.service";
import {Shipment} from "../../../../../../open-api-generated/models/shipment";
import {ClientDeliveryService} from "../../../../../../enums/client-delivery-service";
import {Country} from "../../../../../../open-api-generated/models/country";
import {InterestedEntity} from "../../../../../../open-api-generated/models/interested-entity";
import {ToastsService} from "../../../../../../services/toasts.service";
import {ClientsService} from "../../../../../../services/clients/clients.service";
import {ClientPanelService} from "../../../../../../open-api-generated/services/client-panel.service";


@Component({
  selector: 'app-shipment-info-card',
  templateUrl: './shipment-info-card.component.html',
  styleUrls: ['./shipment-info-card.component.scss']
})
export class ShipmentInfoCardComponent implements OnInit {
  returnDeliveryServiceIds: number[] = [ClientDeliveryService.HomeReturn, ClientDeliveryService.LockerReturn];
  lockerDeliveryServiceIds: number[] = [ClientDeliveryService.LockerDelivery, ClientDeliveryService.LockerReturn];
  selectedCountryId: number = null;
  validationErrors = null;
  countries: Country[] = [];

  @Input('formDisabled') formDisabled: boolean;
  @Input('isCreatingFrom') isCreatingForm: boolean;
  @Input('shipment') shipment: Shipment = null;
  @Input('isClient') isClient: boolean = true;
  @Input('activeParcelCardName') activeParcelCardName: string = null;

  constructor(
    private router: Router,
    private shipmentService: ShipmentService,
    private clientService: ClientsService,
    private toastsService: ToastsService,
    private clientPanelService: ClientPanelService,
  ) {
  }

  ngOnInit(): void {
    if (false === this.isCreatingForm) {
      this.completeData();
    }
    else {
      this.addParcel();

      this.clientPanelService.appV2ClientPanelAllowedCountries({}).subscribe(
        (countries: Country[]) => {
          this.countries = countries;
        }
      );
    }
  }

  activeParcelCardChanged(cardName: string): void {
    this.activeParcelCardName = cardName;
  }

  completeData(): void {
    if (null === this.shipment.waybill) {
      setTimeout(
        (): void => {
          this.completeData();
        }, 10
      );

      return;
    }

    this.formDisabled = null !== this.shipment.internal_info.correctly_requested_at
      || null !== this.findBufferNumber()
      || null !== this.findDuplicatedNumber()
    ;

    this.shipmentCod = this.shipment.content.cash_on_delivery_value > 0;

    if (null === this.activeParcelCardName) {
      for (let parcel of this.shipment.parcels) {
        this.activeParcelCardName = parcel.waybill.internal;
        break;
      }
    }

    this.findAllowedCountries();
  }

  clientChangedEventHandler(clientId: number): void {
    this.shipment.client_id = clientId;
    this.findAllowedCountries();
  }

  shipmentCod: boolean = false;

  cashOnDeliveryChanged(): void {
    if (false === this.shipmentCod) {
      this.shipment.content.cash_on_delivery_value = 0;
    }
  }

  countryChanged(): void {
    for (const country of this.countries) {
      if (country.id == this.selectedCountryId) {
        this.shipment.content.currency = country.currency;
        if (this.isReturnService()) {
          this.shipment.sender.country = country;
          this.shipment.sender.locker = {
            id: null,
            name: null
          };
          this.shipment.sender.address.locality = {
            id: null,
            name: null,
          };
          this.shipment.sender.address.postal_code = null;
        }
        else {
          this.shipment.recipient.country = country;
          this.shipment.recipient.locker = {
            id: null,
            name: null
          };
          this.shipment.recipient.address.locality = {
            id: null,
            name: null,
          };
          this.shipment.recipient.address.postal_code = null;
        }

        return;
      }
    }
  }

  isReturnService(): boolean {
    for (let serviceId of this.returnDeliveryServiceIds) {
      if (serviceId == this.shipment.delivery_service) {
        return true;
      }
    }

    return false;
  }

  isLockerService(): boolean {
    for (let serviceId of this.lockerDeliveryServiceIds) {
      if (serviceId == this.shipment.delivery_service) {
        return true;
      }
    }

    return false;
  }

  interestedEntityChangedEventHandler(isSender: boolean, entity: InterestedEntity): void {
    if (isSender) {
      this.shipment.sender = entity;
    }
    else {
      this.shipment.recipient = entity;
    }
  }

  serviceChanged(): void {
    if (this.isLockerService() && this.shipment.parcels.length > 1) {
      this.toastsService.showMessage('Nie można nadać wielopaka z i do automatu paczkowego!', 'e');
    }

    for (const country of this.countries) {
      if (country.id == this.selectedCountryId) {
        if (this.isReturnService()) {
          this.shipment.sender.country = country;
        }
        else {
          this.shipment.recipient.country = country;
        }
      }
    }
  }

  addParcel(): void {
    this.shipment.parcels.push(
      {
        waybill: null,
        in_shipment_order: 1,
        dimensions: {
          measured: null,
          declared: {
            height: 0,
            length: 0,
            width: 0,
          },
        },
        weight: {
          measured: null,
          declared: 0,
        }
      }
    );
  }

  deleteParcel(index: number): void {
    this.shipment.parcels.splice(index, 1);
  }

  submitUpdate(): void {
    this.shipmentService.appV2ShipmentUpdate(
      {
        body: {
          id: this.shipment.internal_info.shipment_id,
          delivery_service: this.shipment.delivery_service,
          additional_data: this.shipment.additional_data,
          client_id: this.shipment.client_id,
          content: this.shipment.content,
          sender: this.isReturnService() ? this.shipment.sender : null,
          recipient: this.isReturnService()? null : this.shipment.recipient,
          parcels: this.shipment.parcels,
        }
      }
    ).subscribe(
      (): void => {
        this.toastsService.showMessage('Pomyślnie zapisano zmiany!', 's');
      },
      (): void => {
        this.toastsService.showMessage('Nie można zapisać zmian!', 'e');
      }
    )
  }

  submitStore(): void {
    if (this.isLockerService() && this.shipment.parcels.length > 1) {
      this.toastsService.showMessage('Nie można nadać wielopaka z i do automatu paczkowego!', 'e');
      return;
    }

    this.shipmentService.appV2ShipmentStore(
      {
        body: {
          delivery_service: +this.shipment.delivery_service,
          additional_data: this.shipment.additional_data,
          client_id: this.shipment.client_id,
          content: this.shipment.content,
          sender: this.isReturnService() ? this.shipment.sender : null,
          recipient: this.isReturnService()? null : this.shipment.recipient,
          parcels: this.shipment.parcels,
        },
      }
    ).subscribe(
      (response: any) => {
        this.toastsService.showMessage('Przesyłka została utworzona poprawnie!', 's');
        setTimeout(
          (): void => {
            this.router.navigateByUrl('/shipment/' + response.internal_waybill);
          }
        );

        this.validationErrors = {};
      },
      (e: any) => {
        this.validationErrors = {};

        if (422 === e.status) {
          this.validationErrors = e.error.errors.validation;
          this.toastsService.showMessage('Dane przesyłki są nieprawidłowe', 'e');

          return;
        }

        if (451 === e.status) {
          this.toastsService.showMessage('Nadawanie do tego kraju jest niedozwolone!', 'e');
          return;
        }
      }
    )
  }

  findAllowedCountries(): void {
    if (null === this.shipment.client_id) {
      setTimeout(
        (): void => {
          this.findAllowedCountries();
        },
        100
      );

      return;
    }

    this.clientService.findClientCountries(this.shipment.client_id).subscribe(
      (response: any[]): void => {
        this.countries = response;
      }
    )
  }

  findBufferNumber(): string {
    for (let parcel of this.shipment.parcels) {
      return parcel.waybill.external_buffer;
    }
  }

  findDuplicatedNumber(): string {
    for (let parcel of this.shipment.parcels) {
      return parcel.waybill.external_duplicated;
    }
  }
}
